<template>
<transition name="modal">
<div id='video'>
	<div class="player-container">
      <div class="header-container">
         <span class="header-title"></span>
      </div>
      <ul id="main_list">
         <!-- <video id="video" name="media" controls controlsList="nodownload"
               :poster="this.GALLERY_HOST + '/' + zone10.thumb" :src="this.GALLERY_HOST + '/' + zone10.val" type="video/mp4">
         </video>
         <video id="video" name="media" controls controlsList="nodownload" :poster="this.GALLERY_HOST + '/' + zone10.thumb" 
               :src="this.GALLERY_HOST + '/' + zone10.val" type="video/mp4">
         </video> -->
         <div v-for="(video, index) in asset.val"
               :key="index" class="thumb-wrapper">
            <img :src="GALLERY_HOST + '/' + asset.thumb[index]" :data-val="video">
         </div>
      </ul>
      <div class="video-inner-wrapper">
         <div id="jquery_jplayer_1" class="jp-jplayer"></div>
         <div id="jp_container_1" class="jp-audio" role="application" aria-label="media player">
            <div class="jp-padding">
               <div class="jp-type-single">
                  <button id="play">
                     <img src="./assets/img/bttn-play.svg">
                  </button>
                  <button id="pause">
                     <img src="./assets/img/bttn-pause.svg">
                  </button>
                  <div class="progress">
                     <div class="seek-wrapper">
                        <div id="seek_bar">
                           <div id="play_bar">
                              <div class="jp-ball"></div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <span id="duration"></span>
                  <img id="volume_icon" src="./assets/img/icon-volume.svg">
                  <div id="volume_bar">
                     <div id="volume_value"></div>
                  </div>
                  <img id="close_btn_video" class="close-btn-red" @click.stop="$emit('close')" src="./assets/img/bttn-close.svg">
               </div>
            </div>
         </div>
      </div>

       <div class="carousel-btns" v-if="asset.val.length > 1">
         <div class="prev-wrapper-aud carousel-btn-wrapper">
            <img class="prev" @click="handleSwitch" src="./assets/img/bttn-left.svg">
         </div>

         <div class="next-wrapper-aud carousel-btn-wrapper">
            <img class="next" @click="handleSwitch" src="./assets/img/bttn-right.svg">
         </div>
      </div>
	</div>
</div>
</transition>
</template>

<script>
import Overlay from './Overlay';

export default {
   extends: Overlay,

   data() {
      return {
      }
   },

   created() {

   },

   mounted() {
      let video = this.GALLERY_HOST + '/' + this.asset.val[0];;
      let title = this.asset.title[0];

      let self = this;
      $(function() {
         "use strict";

         //https://stackoverflow.com/questions/4774746/jquery-ajax-wait-until-all-images-are-loaded
         $.fn.imagesLoaded = function () {
            console.log('images');
            // get all the images (excluding those with no src attribute)
            var $imgs = $('#main_list').find('img');
            // if there's no images, just return an already resolved promise
            if (!$imgs.length) {return $.Deferred().resolve().promise();}

            // for each image, add a deferred object to the array which resolves when the image is loaded (or if loading fails)
            var dfds = [];  
            $imgs.each(function(){

               var dfd = $.Deferred();
               dfds.push(dfd);
               var img = new Image();
               img.onload = function(){dfd.resolve();}
               img.onerror = function(){dfd.resolve();}
               img.src = this.src;

            });

            // return a master promise object which will resolve when all the deferred objects have resolved
            // IE - when all the images are loaded
            return $.when.apply($,dfds);

         }

         $("#jquery_jplayer_1").jPlayer({
            ready: function() {
               $(this).jPlayer( "setMedia", {
                  m4v: video
               });

               $(this).jPlayer('play');
            },
            timeupdate: function(event) {
               $("#jp_container_1 .jp-ball").css("left",event.jPlayer.status.currentPercentAbsolute + "%");
            },
            cssSelectorAncestor: "#jp_container_1",
            cssSelector: {
               title: "#title",
               play: "#play",
               pause: "#pause",
               currentTime: "#currentTime",
               duration: "#duration",
               seekBar: "#seek_bar",
               playBar: "#play_bar",
               volumeBar: "#volume_bar",
               volumeBarValue: "#volume_value"
            },
            swfPath: "/js",
            supplied: "m4v, ogv",
            useStateClassSkin: true,
            autoBlur: false,
            smoothPlayBar: true,
            keyEnabled: true,
            remainingDuration: true,
            toggleDuration: true,
            size: {
               width: 1000,
               height: 1400
            },
            ended: function() {
               closeVideo();
            }
         });
	      $('.header-title').text(title);

         var mainSlider = $('#main_list').slick({
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            vertical: false,
            adaptiveWidth: true,
            centerMode: true,
            prevArrow: $('.prev'),
            nextArrow: $('.next'),
         });

          let i = 0;
         self.asset.thumb.forEach((file) => {
            $("#main_list")
               .append('<div class="thumb-wrapper"><img src="' + self.GALLERY_HOST+ '/'+file + '" data-large="' + self.GALLERY_HOST+ '/'+file + '" alt="image'+i+' data-description="" data-val="'+self.asset.val[i]+'"/></div>')
               // .imagesLoaded().then(function() { //once all images are loaded refresh the slider
                  
               //    $('.thumb-wrapper img')
               //       .each(function() {
               //          var $this = $(this);
               //          console.log($this.width());
               //          console.log($this.height());
               //          if (this.width > this.height) {
               //             $this.addClass('landscape');
               //          } else {
               //             $this.addClass('portrait');
               //          }
               //       });
               //    mainSlider.slick('refresh');
               //    mainSlider.show();

               // })
            i++;
         });

         mainSlider.slick('refresh');
         mainSlider.show();

         $('.slick-track').css('display', 'flex');
         $('.slick-track').css('align-items', 'center');

         // $('#main_list').on('beforeChange', function(event, slick, currentSlide, nextSlide){
         //    $('#main_list .slick-slide[data-slick-index="' + currentSlide + '"] .thumb-wrapper img').css('margin', '0 auto');
         // });

         $('#main_list').on('afterChange', function(event, slick, currentSlide, nextSlide){
            var vid = $('#main_list .slick-current img').attr('data-val');
            console.log(vid);
            self.switchVideo(vid);
            $('.header-title').text(self.asset.title[currentSlide]);
            // $('#main_list .slick-slide[data-slick-index="' + currentSlide + '"] .thumb-wrapper img').css('display', 'none');
         });

         $('.thumb-wrapper img')
            .each(function() {
               var $this = $(this);
               if ($this.width() > $this.height()) {
                  $this.addClass('landscape');
               } else {
                  $this.addClass('portrait');
               }
            });
      });
   },

   methods: {
      handleSwitch() {
         $('.jp-jplayer').css('visibility', 'hidden');
      },

      switchVideo(video) {
         let self = this;
         $(function() {
            "use strict";

            $("#jquery_jplayer_1").jPlayer("setMedia", {
               m4v: self.GALLERY_HOST + '/' + video
            });

            $('.jp-jplayer').css('visibility', 'visible');

            $("#jquery_jplayer_1").jPlayer('play');
         });
      }
   }
}
</script>